import { call, put } from "redux-saga/effects";
import { apiGeneral, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { UpdatePermissionActions } from "store/ducks/settings/permissions";

export function* updatePermissionRequest(action: any) {
  try {
    const { id, putData, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.put,
      `/permissions/${id}`,
      putData
    );

    const { data } = responseBody;
    yield put(UpdatePermissionActions.success(data));
    notify("success", "Permissão atualizada com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(UpdatePermissionActions.failure(errorMessage));
  }
}
